<template>
  <!-- <el-form label-width="150px">
    <el-row :gutter="24"> -->
  <div>
    <el-col :xs="24" :sm="24" :md="12" :lg="12">
      <el-form-item :label="$t('City')">
        <el-select
          style="max-width:220px;"
          filterable
          :placeholder="$t('el.select.placeholder')"
          @change="getFac()"
          v-model="Valueform.cityId"
        >
          <el-option
            v-for="(item, index) in area"
            :key="'inx1' + index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col v-if="level > 1" :xs="24" :sm="24" :md="12" :lg="12">
      <el-form-item :label="$t('Campus')">
        <el-select
          filterable
          :placeholder="$t('el.select.placeholder')"
          @change="getBuild()"
          v-model="Valueform.factoryId"
          style="width:100%:"
        >
          <el-option
            v-for="(item, index) in facList"
            :key="'inx2' + index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col v-if="level > 2" :xs="24" :sm="24" :md="24" :lg="24">
      <el-form-item :label="$t('Building')">
        <el-select
          filterable
          :placeholder="$t('el.select.placeholder')"
          @change="getLab()"
          v-model="Valueform.buildingId"
          style="width:100%:"
        >
          <el-option
            v-for="(item, index) in building"
            :key="'inx3' + index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col v-if="level > 3" :xs="24" :sm="24" :md="12" :lg="12">
      <el-form-item :label="$t('Lab')">
        <el-select
          filterable
          :placeholder="$t('el.select.placeholder')"
          v-model="Valueform.LabId"
          @change="getDevide()"
        >
          <el-option
            v-if="comType == 'signalr_curve'"
            value="00000000-0000-0000-0000-000000000000"
            :label="$t('NonLaboratory')"
          ></el-option>
          <el-option
            v-for="(item, index) in labList"
            :key="'inx4' + index"
            :value="item.value"
            :label="item.label"
            v-if="item.value != '00000000-0000-0000-0000-000000000000'"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col
      v-if="level > 4 && comType != 'LabPue'"
      :xs="24"
      :sm="24"
      :md="12"
      :lg="12"
    >
      <el-form-item :label="$t('Equipment')">
        <el-select
          filterable
          :placeholder="$t('el.select.placeholder')"
          @change="emitData"
          v-if="typeDevice && !enablesys"
          v-model="Valueform.deviceId"
        >
          <el-option
            v-for="(item, index) in deviceList"
            :key="'inx5' + index"
            :value="item.value"
            :label="item.label"
            v-if="item.type == typeDevice"
          ></el-option>
        </el-select>
        <el-select
          filterable
          :placeholder="$t('el.select.placeholder')"
          @change="emitData"
          v-if="typeDevice && enablesys == '0'"
          v-model="Valueform.deviceId"
        >
          <el-option
            v-for="(item, index) in deviceList"
            v-if="item.enableInSys == 'false' && item.type == typeDevice"
            :key="'inx5' + index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-select
          filterable
          :placeholder="$t('el.select.placeholder')"
          @change="emitData"
          v-else-if="typeDevice && enablesys == '1'"
          v-model="Valueform.deviceId"
        >
          <el-option
            v-for="(item, index) in deviceList"
            v-if="item.enableInSys == 'true' && item.type == typeDevice"
            :key="'inx5' + index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-select
          filterable
          :placeholder="$t('el.select.placeholder')"
          @change="emitData"
          v-else
          v-model="Valueform.deviceId"
        >
          <el-option
            v-for="(item, index) in deviceList"
            :key="'inx5' + index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="hasDeviceName">
      <el-form-item :label="$t('DeviceName')">
        <el-input
          class="queryform"
          @keyup.enter.native="emitData"
          @blur="emitData"
          v-model="Valueform.DeviceName"
        ></el-input>
      </el-form-item>
    </el-col>
  </div>
  <!-- </el-row> -->
  <!--    </div>-->
  <!-- </el-form> -->
</template>

<script>
import { fancha } from "../../../utils/util";
import { pySort } from "../../../utils/pysort";
export default {
  name: "areaSelect",
  data() {
    return {
      area: JSON.parse(sessionStorage.getItem("area")),
      Valueform: {
        DeviceName: "",
        cityId: "",
        factoryId: "",
        buildingId: "",
        LabId: "",
        deviceId: "",
      },
      facList: [],
      building: [],
      labList: [],
      deviceList: [],
      typeDevice: "",
    };
  },
  watch: {
    formArea(val) {
      //console.log(val)
      this.Valueform = { ...this.Valueform, ...val };
      if (this.Valueform.factoryId) {
        var data = fancha(this.Valueform.factoryId);
        this.facList = this.area[data[0]].children;
        this.building = this.area[data[0]].children[data[1]].children;
      }
      if (!this.Valueform.cityId) {
        this.getDefault();
      }
    },
    deviceType: {
      handler(value, oldValue) {
      
        this.typeDevice = value;
        //console.log(this.typeDevice)
      },
      deep: true,
    },
  },
  props: {
    hasDeviceName: {
      type: Boolean,
      default: false,
    },
    formArea: {
      type: Object,
    },
    level: {
      type: Number,
    },
    deviceType: {
      type: String,
    },
    enablesys: {
      type: String,
      default: "",
    },
    comType: {
      type: String, //模块名称
    },
  },
  mounted() {
    //console.log(this)

    let that = this;

    this.$nextTick(function () {
      that.getDefault();
    });
  },
  methods: {
    getDefault() {
      this.facList = [];
      this.building = [];
      this.labList = [];
      this.deviceList = [];
      //console.log(this.deviceType)
      //console.log(this.enablesys);
      let that = this;
      let area = JSON.parse(sessionStorage.getItem("area"));
      area.forEach((i) => {
        if (i.children) {
          i.children.map((j) => {
            that.facList.push(j);
            if (j.children) {
              j.children.map((k) => {
                that.building.push(k);
                if (k.children) {
                  k.children.map((l) => {
                    if (l.label == "") {
                      l.label = this.$t('NonLaboratory');
                    }
                    that.labList.push(l);
                    if (l.children) {
                      l.children.map((m) => {
                        that.deviceList.push(m);
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
      that.area = pySort(area, "label");
      that.facList = pySort(that.facList, "label");
      that.building = pySort(that.building, "label");
      that.labList = pySort(that.labList, "label");
      that.deviceList = pySort(that.deviceList, "label");
      // that.facList = arr
      //console.log(pySort(area, 'label'))
    },
    getchildList() {
      var arr1 = [],
        arr2 = [],
        arr3 = [],
        arr4 = [],
        e = this.Valueform,
        that = this;
      this.area.forEach((i) => {
        if (i.children && (e.cityId == i.value || !e.cityId)) {
          i.children.map((j) => {
            arr1.push(j);
            if (j.children && (e.factoryId == j.value || !e.factoryId)) {
              j.children.map((k) => {
                arr2.push(k);
                if (k.children && (e.buildingId == k.value || !e.buildingId)) {
                  k.children.map((l) => {
                    arr3.push(l);
                    if (l.children && (e.LabId == l.value || !e.LabId)) {
                      l.children.map((m) => {
                        arr4.push(m);
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
      that.facList = pySort(arr1, "label");
      that.building = pySort(arr2, "label");
      that.labList = pySort(arr3, "label");
      that.deviceList = pySort(arr4, "label");
    },
    getFac() {
      var a = "",
        id = this.Valueform.cityId;
      this.area.map((item, index) => {
        if (id == item.value) {
          a = index;
        }
      });
      //此处不要移动位置↓↓↓↓↓
      this.facList = this.area[a].children;
      this.getchildList();
      //此处不要移动位置↑↑↑↑↑
      // this.building = []
      // this.labList = []
      // this.deviceList = []
      this.Valueform = {
        ...this.Valueform,
        ...{ factoryId: "", buildingId: "", LabId: "", deviceId: "" },
      };
      this.emitData();
    },
    getBuild() {
      var a = "",
        id = this.Valueform.factoryId;
      this.facList.map((item, index) => {
        if (id == item.value) {
          a = index;
        }
      });
      //此处不要移动位置↓↓↓↓↓
      this.building = this.facList[a].children;
      this.getchildList();
      //此处不要移动位置↑↑↑↑↑
      // this.labList = []
      // this.deviceList = []
      this.Valueform = {
        ...this.Valueform,
        ...{ buildingId: "", LabId: "", deviceId: "" },
      };
      this.emitData();
    },
    getLab() {
      var a = "",
        id = this.Valueform.buildingId;
      this.building.map((item, index) => {
        if (id == item.value) {
          a = index;
        }
      });
      //此处不要移动位置↓↓↓↓↓
      this.labList = this.building[a].children;
      this.getchildList();
      //此处不要移动位置↑↑↑↑↑
      // this.deviceList = []
      this.Valueform = { ...this.Valueform, ...{ LabId: "", deviceId: "" } };
      this.emitData();
    },
    getDevide() {
      var a = "",
        id = this.Valueform.LabId;
      this.labList.map((item, index) => {
        if (id == item.value) {
          a = index;
        }
      });
      //此处不要移动位置↓↓↓↓↓
      this.deviceList = this.labList[a].children;
      this.getchildList();
      //此处不要移动位置↑↑↑↑↑
      this.Valueform = { ...this.Valueform, ...{ deviceId: "" } };
      this.emitData();
    },
    emitData() {
      this.$emit("areaList", { Valueform: this.Valueform });
    },
  },
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
